import { configType } from "./model";
const config: configType = {
  mapboxToken:
    "pk.eyJ1Ijoia2F5cnJvcyIsImEiOiJjbGgwYzNtMmUwcnoxM2NwbmhzaWRzb3YzIn0.B70NhRO--uB4FnvDxHDzEg",
};
export default config;
